import { recursivePropTypeCheck } from '../../../utils/proptypeTools';

const BulkImportTypes = {
  CONTROLROOM:'controlRoom',
  SPORTROOM:'sportRoom',
  SPORTROOMCONTENTS:'sportRoomContents',
  SPORTROOMCONFIG:'sportRoomConfigs',
  CONTENT:'content',
  CATEGORIES:'categories',
  CONFIG:'sportRoomConfig',
  WHITELABELCONFIG: 'whiteLabelConfig', 
};


export default BulkImportTypes;
